import Vue from 'vue'
import Router from 'vue-router'
import {routers} from '../pages'

function initRouter () {
  let values = Object.keys(routers)
  let list = []
  let isInited
  values.forEach((key) => {
    if (!isInited) {
      isInited = true
      list.push({path: '/', redirect: '/' + key})
    }
    if(key === 'LawAndPrivate' || key === 'Lawyer' || key === 'Information' || key === 'ServiceMall') {
      list.push({path: '/' + key + '/:id?/:sub?', name: key, component: routers[key], meta: {
        keepAlive: true, //此组件需要被缓存
    }})
    } else {
      list.push({path: '/' + key + '/:id?/:sub?', name: key, component: routers[key], meta: {
        keepAlive: false, //此组件不需要被缓存
    }})
    }
    
  })
  console.log(list, 'rpuitelist')
  return list
}

Vue.use(Router)

export default new Router({
  routes: initRouter()
})



// WEBPACK FOOTER //
// ./src/router/index.js